import gql from 'graphql-tag'

export default gql`
  query {
    spendPrefundAmount @client {
      value
    }
  }
`
